module.exports = __webpack_public_path__ + "static/assets/2fb4ec8b5ac1043191d8412e25665a04.svg";